// extracted by mini-css-extract-plugin
export default {"root":"_6BDYo","container":"cPq0D"};